import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const FileDownloadIcon = createSvgIcon(
  <>
    <title>file download</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <line
        data-cap="butt"
        data-color="color-2"
        fill="none"
        strokeLinecap="butt"
        strokeMiterlimit="10"
        x1="16"
        x2="16"
        y1="1"
        y2="14"
      />
      <polyline
        fill="none"
        points="24 11 26 11 31 20 31 30 1 30 1 20 6 11 8 11"
        stroke="#222222"
        strokeMiterlimit="10"
      />
      <polyline
        data-color="color-2"
        fill="none"
        points="21 9 16 14 11 9"
        strokeMiterlimit="10"
      />
      <polyline
        data-cap="butt"
        fill="none"
        points="31 20 21 20 21 23 11 23 11 20 1 20"
        stroke="#222222"
        strokeLinecap="butt"
        strokeMiterlimit="10"
      />
    </g>
  </>
)
